var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.205,
    height: 17.943,
    viewBox: "0 0 14.205 17.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1775",
    "data-name": "Rectangle 1775",
    width: 14.205,
    height: 17.943,
    fill: "#77868d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3501",
    "data-name": "Group 3501",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3329",
    "data-name": "Group 3329",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11131",
    "data-name": "Path 11131",
    d: "M7.1,0A7.1,7.1,0,0,0,0,7.031C0,11.9,6.26,17.309,6.524,17.54a.892.892,0,0,0,1.155,0C7.989,17.309,14.2,11.9,14.2,7.031A7.1,7.1,0,0,0,7.1,0m0,15.667c-1.484-1.41-5.326-5.326-5.326-8.636a5.326,5.326,0,0,1,10.652,0c0,3.283-3.842,7.226-5.326,8.636",
    transform: "translate(0.003 0.055)",
    fill: "#77868d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11132",
    "data-name": "Path 11132",
    d: "M6.482,3A3.107,3.107,0,1,0,9.589,6.107,3.108,3.108,0,0,0,6.482,3m0,4.438A1.331,1.331,0,1,1,7.813,6.107,1.332,1.332,0,0,1,6.482,7.438",
    transform: "translate(0.622 0.605)",
    fill: "#77868d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.08f00caef7d46564497afb27f983689e.svg";
export { ForwardRef as ReactComponent };